import { composeClassNames } from "@faedev/editor-utils";
import React, { CSSProperties, ReactNode } from "react";
import { sHeading } from "src/styles/sHeading.module.scss";
import { CSSTextAlign } from "src/types/CSSTextAlign";
import { VariantColor } from "src/types/VariantColor";
import { VariantSize } from "src/types/VariantSize";

type HeadingProps = {
  align?: CSSTextAlign | null | undefined;
  className?: (string | string) | null | undefined;
  reference?: React.MutableRefObject<any>;
  size?: VariantSize | null | undefined;
  style?: CSSProperties | null | undefined;
  title: ReactNode;
  type: React.ElementType;
  uppercase?: boolean;
  variant?: VariantColor | null | undefined;
};

function Heading({
  align,
  className,
  reference,
  size,
  style,
  title,
  type,
  uppercase,
  variant,
}: HeadingProps) {
  const HeadingTag = type;
  return (
    <HeadingTag
      className={composeClassNames([
        sHeading,
        type,
        variant,
        align,
        size,
        uppercase && "uppercase",
        className,
      ])}
      style={style}
      ref={reference}
    >
      {title}
    </HeadingTag>
  );
}

export default Heading;
